import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext(null);

const MAIN_API_URL =
  process.env.REACT_APP_MAIN_API_URL || "http://localhost:8060";

export const AuthProvider = ({ children, userData }) => {
  const [user, setUser] = useState(() => {
    if (userData && userData.telegram_id) {
      return {
        username: userData.username,
        phone: userData.phone,
        balance: userData.balance,
        telegram_id: userData.telegram_id,
      };
    }
    return null;
  });

  const [phoneStatus, setPhoneStatus] = useState("unknown");

  const isValidPhone = (p) => !!p && p !== "null" && p !== "None" && p !== "Not registered";

  useEffect(() => {
    if (!user || !user.telegram_id) return;
    const fetchBalance = () => {
      axios
        .get(`${MAIN_API_URL}/auth/user/${user.telegram_id}`)
        .then((res) => {
          const backendUsername = res.data.username;
          const backendPhone = res.data.phone_number;
          const updated = {
            username: (backendUsername && backendUsername !== "None" && backendUsername !== "null") ? backendUsername : user.username,
            phone: (backendPhone && backendPhone !== "null" && backendPhone !== "None" && backendPhone !== "Not registered") ? backendPhone : user.phone || "Not registered",
            balance: (res.data.balance != null && parseFloat(res.data.balance)) || user.balance || 0,
            promo_balance: (res.data.promo_balance != null && parseFloat(res.data.promo_balance)) || 0,
            telegram_id: user.telegram_id,
          };
          setUser(updated);
          setPhoneStatus(isValidPhone(backendPhone) ? "ok" : "missing");
          localStorage.setItem("lala_user", JSON.stringify(updated));
        })
        .catch(() => {});
    };
    fetchBalance();
    const interval = setInterval(fetchBalance, 30000);
    const onFocus = () => fetchBalance();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(interval); window.removeEventListener("focus", onFocus); };
  }, []);

  const refreshUser = () => {
    if (user && user.telegram_id) {
      axios
        .get(`${MAIN_API_URL}/auth/user/${user.telegram_id}`)
        .then((res) => {
          const backendUsername = res.data.username;
          const backendPhone = res.data.phone_number;
          const updated = {
            username: (backendUsername && backendUsername !== "None" && backendUsername !== "null") ? backendUsername : user.username,
            phone: (backendPhone && backendPhone !== "null" && backendPhone !== "None" && backendPhone !== "Not registered") ? backendPhone : user.phone || "Not registered",
            balance: (res.data.balance != null && parseFloat(res.data.balance)) || user.balance || 0,
            promo_balance: (res.data.promo_balance != null && parseFloat(res.data.promo_balance)) || 0,
            telegram_id: user.telegram_id,
          };
          setUser(updated);
          setPhoneStatus(isValidPhone(backendPhone) ? "ok" : "missing");
          localStorage.setItem("lala_user", JSON.stringify(updated));
        })
        .catch(() => {});
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        refreshUser,
        phoneStatus,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
